import { DEFAULT_DATE_FORMAT } from '@/components/constants';
import { useQueryUser } from '@/hooks/query/useQueryUser';
import { cn } from '@/lib/cn';
import { getEhrApptTime } from '@/utils/integration/parse-ehr-appt-time';
import { buttonVariants } from '@heidi/design-system/button';
import { TypographyCaption, TypographyP2 } from '@heidi/design-system/typography';
import { type EHRAppointment } from '@heidi/integrations/ehr/contracts';
import { useRouter } from 'next/router';
import { memo } from 'react';
import { type DebouncedState } from 'use-debounce';

type Props = {
  appt: EHRAppointment;
  handleSessionStart: DebouncedState<(appt: EHRAppointment) => Promise<void>>;
};

const EhrSessionItem = memo(({ appt, handleSessionStart }: Props) => {
  const router = useRouter();
  const { data: user_date_format } = useQueryUser(
    (data) => data.session_settings?.date_format || DEFAULT_DATE_FORMAT
  );

  return (
    <div
      className={cn(
        buttonVariants({ variant: 'ghost', size: 'lg' }),
        'group flex h-12 cursor-pointer justify-start gap-x-3 hover:bg-background-secondary',
        appt.session_id &&
          router.asPath.includes(appt.session_id) &&
          'bg-background-secondary'
      )}
      onClick={() => void handleSessionStart(appt)}
    >
      <div className="ml-2 flex flex-col overflow-hidden">
        <TypographyP2 className="truncate duration-200">
          {`${appt.patient_first_name || ''} ${appt.patient_last_name || ''}`}
        </TypographyP2>
        <TypographyCaption>
          {getEhrApptTime(appt.appointment_date_time, user_date_format)}
        </TypographyCaption>
      </div>
    </div>
  );
});

EhrSessionItem.displayName = 'EhrSessionItem';
export default EhrSessionItem;
